import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {ClickEventHandler} from '../../../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {PaletteColorsEnum} from '../../../../../../../libs/shared/core/src/models/api/paletteModel';
import {ButtonChrome} from '../../../../../../../libs/shared/ui/src/components/buttons/buttonChrome';
import {ButtonVariantsEnum} from '../../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {ButtonContent} from '../../../../../../../libs/shared/ui/src/components/buttons/buttonContent';
import {ChromelessButton} from '../../../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {VisualSizesEnum} from '../../../../../../../libs/shared/ui/src/styles/commonStyles';
import {ellipsis} from '../../../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface TagDropdownCreateButtonProps {
  onClick: ClickEventHandler;
  variant: ButtonVariantsEnum;
}

/*
 * Styles.
 */

const StyledCreateChromelessButton = styled(ChromelessButton)`
  display: inline-block;
  > div {
    ${ellipsis()};
  }
`;

const StyledCreateButtonContent = styled(ButtonContent)`
  ${ellipsis()};
  max-width: 220px;
`;

const StyledButtonChrome = styled(ButtonChrome)`
  margin: 28px 4px 0px;
`;

export const TagDropdownCreateButton: FC<PropsWithChildren<TagDropdownCreateButtonProps>> = (props) => (
  <StyledButtonChrome size={VisualSizesEnum.MEDIUM} variant={props.variant}>
    {() => (
      <StyledCreateChromelessButton onClick={props.onClick}>
        <StyledCreateButtonContent
          size={VisualSizesEnum.SMALL}
          variant={props.variant}
          color={PaletteColorsEnum.BLUE}
        >
          {props.children}
        </StyledCreateButtonContent>
      </StyledCreateChromelessButton>
    )}
  </StyledButtonChrome>
);
